export const compare = (key: string, ascending = true) => (a: any, b: any) => {
  // equal items sort equally
  if (a[key] === b[key]) {
    return 0;
  }

  // nulls sort after anything else
  if (a[key] === null) {
    return 1;
  }
  if (b[key] === null) {
    return -1;
  }

  // otherwise, if we're ascending, lowest sorts first
  if (ascending) {
    return a[key] < b[key] ? -1 : 1;
  }

  // if descending, highest sorts first
  return a[key] < b[key] ? 1 : -1;
};
